import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const usePaymentRequestDetail = (id: number, group: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [paymentList, setPaymentList] = useState<PaymentRequestItemDto[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const { refetch, isLoading } = useQuery(
    [endpoints.payment.info_request, {id: id, group: group}],
    () =>
      fetcher.payment.postPaymentRequstInfo({id: id, group: group}),
    {
      onSuccess: (res: PaymentRequestDetailResDto) => {
        switch (res.code) {
          case 200:
            setPaymentList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: paymentInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.payment.info_add],
    fetcher.payment.postPaymentInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { isLoading, paymentList, paymentInsert, insertSuccess};
};

export default usePaymentRequestDetail;
